<template>
    <div class="bg-[#23242A] text-white custom p-3" id="content_screen">
      <div :class="'p-3 flex content-main ' + (action.component ? ' half-it gap-5' : 'gap-5')">
        <div class="custom-full custom-left">
          <div class="bg-[#2B2C32] rounded-lg px-[16px]">
            <template v-if="vg_selectedLocation.id">
              <div class="flex justify-between mb-5">
                <h2 class="text-[24px] font-semibold text-white mt-5">Pricing Group</h2>
                <mdicon v-if="can_manage_pricing_groups" @click="add" size="32" name="plus" class="text-white bg-theme-green hover:bg-theme-darkgreen mt-2 py-1 h-10 px-1 text-2xl border-0 rounded-md cursor-pointer"/>
              </div>
              <List :selectedCallback="selectedItem" :clearComponent="clearComponent" :iscomponentactive="action.component ? true : false"/>
            </template>
            <p v-else class="text-center text-theme-red">Please select a location from the top left corner.</p>
          </div>
        </div>
        <div :class="'w-full hidden-component custom-right'" v-if="action.component" >
          <component :is="action.component" :item="action.data" :clearComponent="clearComponent"></component>
        </div>
      </div>
    </div>
</template>

<script>
    import {defineComponent, ref} from "vue"
    import { mapGetters, mapActions, mapMutations } from "vuex";
    import PricingGroupApi from '@/controllers/PricingGroup'
    import List from './List.vue';
    import Add from './Add.vue';
    import Edit from './Edit.vue'
    import Helpers from '@/helpers';

    export default defineComponent({
        name: "ProductPricing",
        components: {
            List,
            Add,
            Edit
        },
        setup() {
            const action = ref({
                component: '',
                data: {},
            });
            return {
                action,
            }
        },
        watch: {
            'vg_selectedLocation'(val) {
            // if location selected clear component
            this.clearComponent();
            },
        },
        computed: {
            can_manage_pricing_groups() {
                return Helpers.getMyPermission('can_manage_pricing_groups')
            },
            ...mapGetters({
            vg_selectedLocation: 'location/selected'
            }),
        },
        methods: {
            /**
             * Clear action
             */
            clearComponent() {
                this.action = {
                    component: '',
                    data: {},
                };
                let activeItem = document.getElementsByClassName('active-row');
                if(activeItem.length > 0){
                    activeItem[0].classList.remove("active-row");
                }
            },

            add(){
                this.action = { component: 'Add', data: {}}
            },

            /**
             * Capture selected item
             */
            selectedItem(item) {
                this.action = { component: 'Edit', data: item}
            },

            ...mapActions({
                va_spinner: 'spinner/setSpinner',
            })
        }
    })
</script>